import { Environment } from "@react-three/drei";
export const Env = () => {
    return (
        <Environment
            files={`${process.env.PUBLIC_URL}/assets/textures/hdri/empty_warehouse_01_1k.hdr`}
        />
    );
};
